<template>
  <div>
    <!-- info -->
    <b-alert
      v-if="isDemoStore()"
      variant="info"
      show
    >
      <div class="alert-body">
        <span>{{ $t('message.demoStoreNotice.text') }} <a :href="registerUrl()">{{ $t('message.demoStoreNotice.action') }}</a></span>
      </div>
    </b-alert>

    <div
      v-for="(alert, index) in visibleAlerts"
      :key="`alert-${index}`"
    >
      <template v-if="alert.card === 'launch'">
        <launch-store-card
          v-if="alert.card === 'launch'"
          :title="alert.title"
          :text="alert.text"
          :button="alert.button"
          :price="alert.price.string"
          :sale-price="alert.salePrice.string"
          :price-suffix="alert.priceSuffix"
        />
      </template>
    </div>
  </div>
</template>

<script>
import { BAlert } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { dashboardHost, useRouter } from '@core/utils/utils'
import LaunchStoreCard from '@/views/pages/index/LaunchStoreCard.vue'
import { computed, ref } from 'vue'
import { isUserLoggedIn } from '@/auth/utils'
import store from '@/store'

export default {
  directives: {
    Ripple,
  },
  components: {
    LaunchStoreCard,
    BAlert,
  },
  methods: {
    getGlobalAlerts() {
      return this.$store.state?.storeConfig?.data?.global_alerts
    },
    isDemoStore() {
      return this.$store.state?.storeConfig?.data?.is_demo
    },
    registerUrl() {
      return `https://${dashboardHost()}/register?utm_source=demo_alert`
    },
  },
  setup() {
    /* eslint-disable global-require */
    const alerts = ref([])

    if (isUserLoggedIn()) {
      store.dispatch('alerts/fetchAll').then(response => {
        alerts.value = response.data.data
      })
    }

    const { route } = useRouter()

    const visibleAlerts = computed(() => alerts.value.filter(alert => {
      if (alert.visibility) {
        if (alert.visibility.hide_on_pages && (alert.visibility.hide_on_pages.indexOf(route.value.name) !== -1)) {
          return false
        }
      }
      return true
    }))

    return {
      visibleAlerts,
    }
  },
}
</script>
